/**
 * @name COMPARE
 * @string
 * @description Indicates the product rows to be displayed.
 */
export const COMPARE = 'sel';

/**
 * @name COMPARE_REGEXP
 * @regexp
 * @description Determines if the hash value is a comparison
 */
export const COMPARE_REGEXP = /^sel=(.*?)/;

/**
 * @name INITIATOR
 * @string
 * @description Indicates beginning of the hash
 */
export const INITIATOR = '#/';

/**
 * @name INITIATOR_ALT
 * @string
 * @description Indicates beginning of the hash
 */
export const INITIATOR_ALT = '#';

/**
 * @name PARAMETERS_ADDITIONAL_DISPLAY
 * @string
 * @description Indicate parameters to be displayed in addition to the default parameters
 */
export const PARAMETERS_ADDITIONAL_DISPLAY = 'ca';

/**
 * @name PARAMETERS_DISPLAY
 * @string
 * @description Indicates parameter display override. Only displays parameters defined by this key
 */
export const PARAMETERS_DISPLAY = 'd';

/**
 * @name PARAMETER_REGEXP
 * @regexp
 * @description Determines if the hash value is a parameter filter
 */
export const PARAMETER_REGEXP = /^p([a-z0-9]+)=(.*?)$/;

/**
 * @name PARAMETER_VALUE
 * @string
 * @description Indicates the values of parameters that a part must have in order to be displayed
 */
export const PARAMETER_VALUE = 'p{id}';

/**
 * @name SORT
 * @string
 * @description Indicates the parameters to be sorted.
 */
export const SORT = 'sort';

/**
 * @name SORT_ASCENDING
 * @string
 * @description Indicates the an ascending sort order
 */
export const SORT_ASCENDING = 'asc';

/**
 * @name SORT_DESCENDING
 * @string
 * @description Indicates the an descending sort order
 */
export const SORT_DESCENDING = 'desc';

/**
 * @name SORT_REGEXP
 * @regexp
 * @description Determines if the hash value is a sort
 */
export const SORT_REGEXP = /^sort=(.*?)/;

/**
 * @name QUICK_SEARCH
 * @string
 * @description Indicates the values submitted by the quick search
 */
export const QUICK_SEARCH = 'qsfv';

/**
 * @name QUICK_SEARCH_REGEXP
 * @string
 * @description Determines if the hash value is a quick search
 */
export const QUICK_SEARCH_REGEXP =  /^qsfv=(.*?)/;

/**
 * @name AND_TOGGLE_REGEXP
 * @regexp
 * @description Determines if the hash value is a sort
 */
 export const AND_TOGGLE_REGEXP = /^andToggle=(.*?)/;

 /**
 * @name AND_TOGGLE
 * @string
 * @description Indicates the chekbox parameters to use AND.
 */
export const AND_TOGGLE = 'andToggle';